import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import Tour from 'reactour';
import { enableBodyScroll } from 'body-scroll-lock';
import {
  setTourOpen,
  setTourProps,
  setTourSteps,
} from '../../../../actions/tourActions';
import { HOME } from '../../../../constants/paths';
import { tourDefaultState } from '../../../../reducers/tourReducer';
import DialogTitleWithClose from '../DialogTitleWithClose/DialogTitleWithClose';
import LandingPageTourSteps from './steps/LandingPageTourSteps';
import tourStorage from './tourStorage/tourStorage';

const TourGuide = ({
  steps,
  open,
  props,
  setTourSteps,
  setTourOpen,
  setTourProps,
  tourRef,
  name,
}) => {
  const { preventClose } = props;

  const [openWarning, setOpenWarning] = useState(false);
  // const disableBody = (target) => disableBodyScroll(target);
  // const enableBody = (target) => enableBodyScroll(target);
  const routeHome = useRouteMatch({
    path: HOME,
    exact: true,
  });

  const LandingPageSteps = LandingPageTourSteps();
  const handleClose = (e) => {
    enableBodyScroll(e); // This will allow scrolling to resume whenever the tour is closed
    setTourOpen(false);
    if (preventClose && name === 'Global Tour') {
      const totalSteps = tourRef.current.props.steps.length;
      const currentStep = tourRef.current.state.current + 1;
      if (currentStep < totalSteps) {
        setOpenWarning(true);
      } else {
        tourStorage.set(false);
      }
    }
    setTourProps({ ...tourDefaultState.props });
  };

  useEffect(() => {
    let mounted = true;
    if (mounted && !steps && routeHome) {
      setTourSteps(LandingPageSteps);
      setTourProps({
        preventClose: true,
        disableInteraction: true,
        closeWithMask: false,
      });
      setTourOpen(tourStorage.get());
    }
    return () => {
      mounted = false;
    };
  }, [
    steps,
    setTourSteps,
    LandingPageSteps,
    routeHome,
    setTourProps,
    setTourOpen,
  ]);
  return (
    <>
      <Tour
        {...props}
        onRequestClose={handleClose}
        steps={steps || []}
        rounded={5}
        isOpen={open}
        accessibilityOptions={{ closeButtonAriaLabel: 'Close' }}
      />
      <Dialog open={openWarning}>
        <DialogTitleWithClose
          onClose={() => {
            tourStorage.set(false);
            setOpenWarning(false);
          }}
        >
          Tour closed
        </DialogTitleWithClose>
        <DialogContent>
          <Typography>{`You've closed the tour early would you like to see it again next
              time you log in?`}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              tourStorage.remove();
              setOpenWarning(false);
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              tourStorage.set(false);
              setOpenWarning(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  steps: state.tour.steps,
  open: state.tour.open,
  props: state.tour.props,
  name: state.tour.props.name,
  tourRef: state.tour.props.ref,
});

TourGuide.propTypes = {
  steps: PropTypes.array,
  props: PropTypes.object,
  open: PropTypes.bool.isRequired,
  setTourSteps: PropTypes.func.isRequired,
  setTourOpen: PropTypes.func.isRequired,
  setTourProps: PropTypes.func.isRequired,
  preventClose: PropTypes.bool,
  tourRef: PropTypes.object,
  name: PropTypes.string,
};

TourGuide.defaultProps = {
  steps: undefined,
  preventClose: undefined,
  props: {},
  tourRef: undefined,
  name: undefined,
};

export default connect(mapStateToProps, {
  setTourSteps,
  setTourOpen,
  setTourProps,
})(TourGuide);
